import { render, staticRenderFns } from "./PrizeAddrs.vue?vue&type=template&id=ce248670&scoped=true&"
import script from "./PrizeAddrs.vue?vue&type=script&lang=js&"
export * from "./PrizeAddrs.vue?vue&type=script&lang=js&"
import style0 from "./PrizeAddrs.vue?vue&type=style&index=0&id=ce248670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce248670",
  null
  
)

export default component.exports